import React, { useState } from "react";
import axios from "axios";
import "../styles/global.css";

const CadastroCheckpointModelo = () => {
  const [categoria, setCategoria] = useState("");
  const [pergunta, setPergunta] = useState("");
  const [mensagem, setMensagem] = useState("");

  const salvar = async () => {
    if (!categoria || !pergunta) {
      setMensagem("Preencha todos os campos.");
      return;
    }

    try {
      const response = await axios.post("/api/checkpoints_modelo/", {
        categoria,
        pergunta,
      });
      setMensagem("Pergunta/Comando cadastrado com sucesso.");
      setTimeout(() => setMensagem(""), 3000); // apaga após 3 segundos
      setCategoria("");
      setPergunta("");
    } catch (error) {
      console.error("Erro ao salvar:", error);
      setMensagem("Erro ao salvar. Verifique o console.");
    }
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Cadastro de Perguntas de CheckPoint</h2>

      <div className="form-group">
        <label>Categoria</label>
        <select
          className="form-control"
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
        >
          <option value="">Selecione uma categoria</option>
          <option value="Reflexão Pessoal">Reflexão Pessoal</option>
          <option value="Aplicação Prática">Aplicação Prática</option>
          <option value="Ensino ao Outro">Ensino ao Outro</option>
          <option value="Dificuldade">Dificuldade</option>
          <option value="Crítica/Opinião">Crítica/Opinião</option>
          <option value="Criatividade">Criatividade</option>
        </select>

      </div>

      <div className="form-group">
        <label>Pergunta</label>
        <textarea
          className="form-control"
          style={{ fontSize: "0.75rem", padding: "10px" }}
          rows={4}
          value={pergunta}
          onChange={(e) => setPergunta(e.target.value)}
        ></textarea>
      </div>

      {mensagem && <p style={{ marginTop: "10px" }}>{mensagem}</p>}

      <div className="form-actions">
        <button className="btn btn-primary" onClick={salvar}>
          Salvar Pergunta
        </button>
      </div>
    </div>
  );
};

export default CadastroCheckpointModelo;
